import { uniqueId } from 'lodash';
import provinceJson from '@/assets/area/province_city';
export const caseTypeList = ['刑事', '民事', '行政', '国家赔偿'];
export const caseTypeListOther = ['管辖案件', '区际司法协助', '国际司法协助', '非诉保全', '司法制裁', '强制清算与破产', '其他'];
import moment from 'moment';
import infoConfig from './infoConfig.json';

export const isDev = process.env.NODE_ENV === 'development';

export const projectInfoConfig = isDev ? infoConfig['home.html'] : infoConfig[window.projectDir];

export const delEmptyRegexp = /^[+|&]+|[-+|&]+$/g;

export const usedLimitErrCode = 200403;
export const blobRequestArr = ['law/download', 'nlp/case/browser/pdf', 'case/download', 'case/report_download', 'prediction/report/download', 'prediction/report/doc'];

export function getFullTextChild(){
  return {
    id: `${Date.now()}_${uniqueId()}`,
    value: '',
    showValue: [],
    keyword: 'para_content',
    searchLimit: '同篇',
    searchLimitDis: false,
    result: [],
    type: 'must'
  };
}

export function getFullReasonChild(){
  return {
    id: `${Date.now()}_${uniqueId()}`,
    value: [],
    showValue: []
  }
}

export const defaultFilterList = [
  {
    name: '全文检索',
    key: 'textSearch',
    inputType: 'matchSelect',
    mulits: true,
    type: 'must',
    bySearchInput: false,
    result: [getFullTextChild(), getFullTextChild()],
    resetFunc: function() {
      this.result = [getFullTextChild(), getFullTextChild()];
    },
    formatter: function (val) {
      this.result.push(val);
    }
  },
  {
    name: '案件类型',
    inputType: 'select',
    mulits: false,
    isBaseNatureCase: true,
    value: [],
    data: [...caseTypeList],
    key: 'base_caseType',
    formatter: function (val) {
      const value = [...this.value, val];
      this.value = [...new Set(value)];
    },
    resetFunc: function () {
      this.value = [];
    }
  },
  {
    name: '审理程序',
    subName: ['聚合审理程序'],
    inputType: 'select',
    mulits: false,
    isBaseNatureCase: true,
    optionProps: {
      expandTrigger: 'hover',
      multiple: true,
      checkStrictly: true,
      emitPath: false,
      value: 'value',
      label: 'name'
    },
    value: [],
    showValue: [],
    data: ['一审', '二审', '再审', '其他'],
    key: 'full_procedureType',
    checkAllName: ['含下级'],
    formatter: function (value, showValue) {
      this.value = value;
      this.showValue = showValue || value;
    },
    resetFunc: function () {
      this.value = [];
      this.showValue = [];
    }
  },
  {
    name: '案由',
    subName: ['聚合案由'],
    inputType: 'matchSelect',
    mulits: true,
    type: 'and',
    result: [ getFullReasonChild(), getFullReasonChild()],
    value: [],
    showValue: [],
    key: 'fullreason',
    checkAllName: ['含下级'],
    formatter: function (value, showValue) {
      this.result = [{
        value: value,
        showValue: showValue || value
      }, getFullReasonChild()];
    },
    resetFunc: function () {
      this.result = [getFullReasonChild(), getFullReasonChild()];
    },
    addRes: function () {
      this.result.push(getFullReasonChild())
    },
    removeRes: function (index) {
      this.result.splice(index, 1)
    },
  },
  {
    name: '裁判日期',
    subName: ['裁判年份'],
    inputType: 'date',
    mulits: false,
    value: [],
    key: 'judgementDate',
    tipText: '',
    formatter: function (val) {
      const year = moment(val).year();
      this.value = [moment(`${year}-01-01`).valueOf(), moment(`${year}-12-31`).valueOf()];
    },
    resetFunc: function () {
      this.value = [];
    }
  },
  {
    name: '文书性质',
    inputType: 'select',
    mulits: false,
    value: [],
    data: [],
    key: 'base_nature',
    formatter: function (val) {
      this.value = [val];
    },
    resetFunc: function () {
      this.value = [];
    }
  }
]

export const optionFilterList = [
  {
    name: '标题',
    inputType: 'input',
    mulits: false,
    value: '',
    key: 'base_title',
    edit: true,
    isBaseNatureCase: true,
    placeholder: '请输入标题',
    edit: true,
    formatter: function(val) {
      this.value = val;
    },
    resetFunc: function() {
      this.value = '';
    }
  },
  {
    name: '案号',
    inputType: 'input',
    mulits: false,
    value: '',
    key: 'base_caseNumber',
    placeholder: '请输入案号',
    edit: true,
    formatter: function(val) {
      this.value = val;
    },
    resetFunc: function() {
      this.value = '';
    }
  },
  // {
  //   name: '地区',
  //   subName: ['地区分布图'],
  //   inputType: 'province_city_cascader',
  //   mulits: false,
  //   value: [],
  //   data: provinceJson,
  //   optionProps: {
  //     expandTrigger: 'hover',
  //     multiple: true,
  //     checkStrictly: true,
  //     value: 'name',
  //     label: 'name'
  //   },
  //   key: 'province_city',
  //   edit: true,
  //   formatter: function (val, {
  //     isProvince = true
  //   }) {
  //     let value = this.value.map(item => item.join('/'));
  //     if (isProvince) {
  //       value.push(val);
  //     } else {
  //       const arr = [...provinceJson];
  //       let provinceItem = null;
  //       let cityItem = null;
  //       while (provinceItem = arr.shift()) {
  //         cityItem = provinceItem.children.find(childItem => {
  //           return childItem.name === val;
  //         });
  //         if (cityItem) {
  //           break;
  //         }
  //       }
  //       if (cityItem) {
  //         value.push(`${provinceItem.name}/${cityItem.name}`);
  //       }
  //     }
  //     value = [...new Set(value)];
  //     this.value = value.map(item => item.split('/'));
  //   },
  //   resetFunc: function () {
  //     this.value = [];
  //   }
  // },
  {
    name: '引用法条',
    inputType: 'matchSelect',
    mulits: true,
    key: 'lawinfo',
    isBaseNatureCase: true,
    type: 'and',
    result: [{
      value: '',
      keyword: '',
      lawRes: []
    }],
    edit: true,
    resetFunc: function () {
      this.result = [{
        value: '',
        keyword: '',
        lawRes: []
      }];
    }
  },
  {
    name: '共同犯罪',
    inputType: 'select',
    key: 'mulit_personal_crime',
    edit: true,
    value: {
      singlePersonal: false,
      mulitPersonal: false,
      singleCrime: false,
      mulitCrime: false
    },
    resetFunc: function () {
      this.value = {
        singlePersonal: false,
        mulitPersonal: false,
        singleCrime: false,
        mulitCrime: false
      };
    }
  },
  // {
  //   name: '律师',
  //   inputType: 'inputText',
  //   mulits: false,
  //   value: '',
  //   key: 'lvshi',
  //   edit: true,
  //   formatter: function(val) {
  //     this.value = val;
  //   },
  //   resetFunc: function() {
  //     this.value = '';
  //   }
  // },
  // {
  //   name: '律所',
  //   inputType: 'inputText',
  //   mulits: false,
  //   value: '',
  //   key: 'lvsuo',
  //   edit: true,
  //   formatter: function(val) {
  //     this.value = val;
  //   },
  //   resetFunc: function() {
  //     this.value = '';
  //   }
  // },
  // {
  //   name: '当事人信息',
  //   inputType: 'inputText',
  //   mulits: false,
  //   value: '',
  //   key: 'dangshiren',
  //   edit: true,
  //   formatter: function(val) {
  //     this.value = val;
  //   },
  //   resetFunc: function() {
  //     this.value = '';
  //   }
  // },
  // {
  //   name: '审判人员',
  //   inputType: 'inputText',
  //   mulits: false,
  //   value: '',
  //   key: 'shenpanrenyuan',
  //   edit: true,
  //   formatter: function(val) {
  //     this.value = val;
  //   },
  //   resetFunc: function() {
  //     this.value = '';
  //   }
  // },
  {
    name: '法院层级',
    subName: ['法院'],
    inputType: 'select',
    mulits: false,
    isSingle: false,
    value: [],
    result: [],
    data: ['最高人民法院', '高级人民法院', '中级人民法院', '基层人民法院'],
    key: 'base_courtLevel',
    edit: true,
    formatter: function (val) {
      this.value = [val];
    },
    resetFunc: function () {
      this.value = [];
    }
  },
  {
    name: '地域及法院',
    subName: ['地区分布图'],
    inputType: 'province_city_cascader',
    mulits: false,
    bySearchInput: false,
    value: [],
    showValue: [],
    key: 'full_base_court',
    edit: true,
    checkAllName: ['所有法院', '本院及辖区法院'],
    formatter: function (value, showValue) {
      this.value = value;
      this.showValue = showValue || value;
    },
    resetFunc: function () {
      this.value = [];
      this.showValue = [];
    }
  },
  // {
  //   name: '审理法院',
  //   inputType: 'base_court',
  //   mulits: false,
  //   isSingle: true,
  //   value: '',
  //   data: [],
  //   optionProps: {
  //     expandTrigger: 'click',
  //     multiple: false,
  //     checkStrictly: true,
  //     emitPath: false,
  //     value: 'value',
  //     label: 'label'
  //   },
  //   key: 'base_court',
  //   edit: true,
  //   formatter: function(val) {
  //     this.value = val;
  //   },
  //   resetFunc: function() {
  //     this.value = '';
  //   }
  // }
]

export const otherFilterList = [{
    name: '案例来源',
    inputType: 'inputText',
    key: 'fullreferencetype',
    value: '',
    isOtherFilter: true,
    formatter: function (val) {
      this.value = val;
    }
  },
  {
    name: '案情特征',
    inputType: 'inputText',
    key: 'labels',
    value: '',
    isOtherFilter: true,
    formatter: function (val) {
      this.value = val;
    }
  }
]


export const lawOptionFilterList = [{
    name: '标题',
    inputType: 'inputText',
    key: 'title',
    mulits: false,
    value: '',
    type: 'string',
    clearable: true,
    placeholder: '多个关键词空格分开',
    formatter: function (val) {
      this.value = val;
    },
    resetFunc: function () {
      this.value = ''
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '全文',
    inputType: 'inputText',
    key: 'fulltext',
    value: '',
    type: 'string',
    clearable: true,
    placeholder: '多个关键词空格分开',
    formatter: function (val) {
      this.value = val;
    },
    resetFunc: function () {
      this.value = ''
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '发布字号',
    inputType: 'inputText',
    key: 'docNum',
    value: '',
    type: 'string',
    clearable: true,
    placeholder: '多个发布字号以空格分开',
    formatter: function (val) {
      this.value = val;
    },
    resetFunc: function () {
      this.value = ''
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '发布日期',
    inputType: 'date',
    key: 'PubTime',
    value: [],
    type: 'date',
    clearable: true,
    placeholder: '选择日期',
    data: [],
    formatter: function (val) {
      const year = moment(val).year();
      this.data = [moment(`${year}-01-01`).valueOf(), moment(`${year}-12-31`).valueOf()];
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '实施日期',
    inputType: 'date',
    key: 'ExecTime',
    value: [],
    type: 'date',
    clearable: true,
    placeholder: '选择日期',
    data: [],
    formatter: function (val) {
      const year = moment(val).year();
      this.data = [moment(`${year}-01-01`).valueOf(), moment(`${year}-12-31`).valueOf()];
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (arr) {
      this.value = arr;
    }
  },
  {
    name: '时效性',
    inputType: 'select',
    key: 'status',
    value: [],
    type: 'array',
    mulits: true,
    filterable: false,
    clearable: true,
    collapseTags: false,
    placeholder: '请输入搜索或选择',
    data: [],
    formatter: function (arr) {
      this.data = arr;
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (arr) {
      this.value = arr;
    }
  },
  {
    name: '发布机关',
    inputType: 'selectTree',
    key: 'publishMachinery',
    value: [],
    type: 'array-tree',
    mulits: false,
    filterable: false,
    clearable: false,
    placeholder: '请输入搜索或选择',
    data: [],
    formatter: function (arr) {
      this.data = arr;
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '效力级别',
    inputType: 'selectTree',
    key: 'category',
    value: [],
    type: 'array-tree',
    mulits: false,
    filterable: false,
    clearable: false,
    placeholder: '请输入搜索或选择',
    data: [],
    formatter: function (arr) {
      this.data = arr;
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '立法资料类别',
    inputType: 'selectTree',
    key: 'classification',
    value: [],
    type: 'array-tree',
    mulits: false,
    filterable: false,
    clearable: false,
    placeholder: '请输入搜索或选择',
    data: [],
    formatter: function (arr) {
      this.data = arr;
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (val) {
      this.value = val;
    }
  },
  {
    name: '征集状态',
    inputType: 'select',
    key: 'collect_status',
    value: [],
    type: 'array',
    mulits: true,
    filterable: false,
    clearable: true,
    collapseTags: false,
    placeholder: '请输入搜索或选择',
    data: [],
    formatter: function (arr) {
      this.data = arr;
    },
    resetFunc: function () {
      this.value = []
    },
    initFunc: function (arr) {
      this.value = arr;
    }
  },
]

export const dragTransformCrimes = [
  '走私、贩卖、运输、制造毒品罪',
  '非法持有毒品罪',
  '窝藏、转移、隐瞒毒品、毒赃罪'
]


// WEBPACK FOOTER //
// ./src/constant.js